import { openDB } from 'idb';

export const saveAudioInIndexDB = async ({
  file = null, 
  practiceid = null, 
  departmentid = null, 
  patientid = null, 
  notes = null, 
  tags = null, 
  patientname = null, 
  templatename = null, 
  role = null, 
  category = null, 
  rowid = null, 
  filename = null, 
  appointmentid = null, 
  status = null, 
  streamingfilename = null,
  userid=null,
    isUploading = false,
  past_visit_confirmed = false,
  client = null,
}) => {
  try {
    // Open or create IndexedDB database
    console.log('attempt saving ')
    const db = await openDB('audioDB', 3, {
      upgrade(db, oldVersion, newVersion, transaction) {
        if (!db.objectStoreNames.contains('audioStore')) {
          db.createObjectStore('audioStore', { keyPath: 'practiceid' });
        }
      },
    });
   
    // After opening the DB, make sure it's accessible
    if (!db.objectStoreNames.contains('audioStore')) {
      console.error('audioStore not found');
    } else {
      console.log('audioStore is accessible');
    }
    // Save data
    await db.put('audioStore', {
      rowid, // Unique identifier
      file, // Audio Blob
      practiceid,
      departmentid,
      patientid,
      notes,
      tags,
      patientname,
      streamingfilename,
      isUploading,
      templatename,
      role,
      category,
      filename,
      appointmentid,
      status,
      userid,
      // Visit consent given before this recording started (see RecordingContext).
      past_visit_confirmed: Boolean(past_visit_confirmed),
      client,
      createdAt: new Date().toISOString(), // Store timestamp
    });

    
    console.log('Audio file saved successfully!');
  } catch (error) {
    console.error('Error saving audio:', error);
  }
};

export const getAudioByPracticeId = async (practiceid) => {
    try {
      const db = await openDB('audioDB', 3);
      const tx = db.transaction('audioStore', 'readonly');
      const store = tx.objectStore('audioStore');
      const allRecords = await store.getAll(); // Get all records
  
      // Filter records by practiceid
      const filteredRecords = allRecords.filter(record => record.practiceid === practiceid);
      
      return filteredRecords;
    } catch (error) {
      console.error('Error retrieving audio by practice ID:', error);
      return [];
    }
  };
  export const getAllAudioRecords = async () => {
    try {
      const db = await openDB('audioDB', 3);
      const tx = db.transaction('audioStore', 'readonly');
      const store = tx.objectStore('audioStore');
      const allRecords = await store.getAll(); // Get all records
  
      return allRecords;
    } catch (error) {
      console.error('Error retrieving all audio records:', error);
      return [];
    }
  };
  

  